<template>
    <div id="newSurvey">
        <topBar :title="$t('newSurvey.statistic')" />
        <div class="commonContainer">
            <div class="filterConditionContainer">
                <el-card class="box-card">
                    <div class="filterCondition">
                        <div class="searchIcon">
                            <i class="el-icon-search"></i>
                        </div>
                        <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
                            <el-form-item :label="$t('survey.name')">
                                <el-input v-model="filterForm.name" :placeholder="$t('survey.chooseName')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('newSurvey.publishTime')">
                                <el-date-picker v-model="filterForm.date" type="daterange" align="left" unlink-panels
                                    range-separator=" - " :start-placeholder="$t('survey.startTime')"
                                    :end-placeholder="$t('survey.endTime')" value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item :label="$t('newSurvey.reportTime')">
                                <el-date-picker v-model="filterForm.date2" type="daterange" align="left" unlink-panels
                                    range-separator=" - " :start-placeholder="$t('survey.startTime')"
                                    :end-placeholder="$t('survey.endTime')" value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                        </el-form>
                        <el-row type="flex" class="row-bg" justify="space-between">
                            <el-col :span="8">
                                <div class="filterBtns">
                                    <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                                    <el-button type="primary" @click="onReset">{{ $t('reset') }}</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <div class="tableContainer">
                <el-card class="box-card">
                    <div class="tableBox">
                        <div class="orangeIcon">
                            <i class="el-icon-s-order"></i>
                        </div>
                    </div>
                    <div style="margin-top: 20px">
                        <el-table :data="tableData" style="width: 100%" :key="1" v-loading="tableLoading">
                            <el-table-column prop="name" :label="$t('newSurvey.surveyName')">
                            </el-table-column>
                            <el-table-column v-if="[0, 1].indexOf(published) > -1" prop="publishTimeDisplay"
                                :label="$t('newSurvey.publishTime')" width="120">
                            </el-table-column>
                            <el-table-column prop="stopTimeDisplay" :label="$t('newSurvey.stopTime')" width="120">
                            </el-table-column>
                            <el-table-column prop="createTime" :label="$t('newSurvey.createTime')" width="120">
                            </el-table-column>
                            <el-table-column prop="updateTimeDisplay" :label="$t('newSurvey.updateTime')" width="120">
                            </el-table-column>
                            <el-table-column prop="publishedStatus" :label="$t('newSurvey.status')" width="100">
                            </el-table-column>
                            <el-table-column :label="$t('operation')" :width="80" fixed="right">
                                <template slot-scope="scope">
                                    <!-- <el-button 
                                    v-if="[1, 2].indexOf(published) > -1 && (isAdmin || canDownload)"
                                        @click="toStatisticDetail(scope.row)" type="text" size="small">{{
                                        $t('newSurvey.showReport') }}</el-button> -->
                                    <el-button @click="toStatisticDetail(scope.row)" type="text" size="small">{{
                                        $t('newSurvey.showReport') }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagingBox">
                            <el-pagination background @current-change="currentChange" :current-page="current"
                                layout="total, prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import TopBar from "../components/TopBar.vue";
import _ from "lodash";
export default {
    name: "StatisticList",
    components: {
        topBar: TopBar
    },
    data: function () {
        return {
            filterForm: {},
            initFilterForm: {
                published: 1, // 状态
                type: null,
                name: "", // 问卷名称
                date: "", // 日期
                date2: ""
            },
            resellerOptions: [],
            tableData: [], // 表格数据
            total: 0,
            current: 1, // 当前页码
            tableLoading: false,
            published: 1,
            questionnaireName: "",
            // canDownload: false
        };
    },

    async beforeMount() {
        this.published = Number(this.$route.query.published || 1);
        this.initFilterForm.published = this.published;
        let queryJson = localStorage.getItem("detailParams");
        if (queryJson) {
            let query = JSON.parse(queryJson);
            this.initFilterForm.date2 = query.startTime
                ? [query.startTime, query.endTime]
                : [];
            localStorage.removeItem("detailParams");
        } else {
            this.initFilterForm.date2 = this.$route.query.startTime
                ? [this.$route.query.startTime, this.$route.query.endTime]
                : "";
        }
        // await this.getCanDownload();
        this.onReset();
        this.onSearch();
        this.loadReseller();
    },
    watch: {
        $route(val) {
            this.published = Number(this.$route.query.published || 1);
            this.initFilterForm.published = this.published;
            this.onReset();
            this.onSearch();
        }
    },
    computed: {
        // statusOptions () {
        //   return [{
        //     label: '已发布',
        //     value: true
        //   },
        //   {
        //     label: '未发布',
        //     value: false
        //   }]
        // },
        // canDownload: ({ $store: { getters } }) => {
        //   console.log(getters.canDownload)
        //   if (getters.canDownload + "" === "true") {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // },
        isAdmin: ({ $store: { getters } }) => {
            if (getters.isAdmin + "" === "true") {
                return true;
            } else {
                return false;
            }
        } // 角色是否是admin
    },
    methods: {
        loadReseller: async function () {
            let res = await window.instance.get(
                window.pubServer + "common/getReseller"
            );
            res = res.data;
            if (res.code === 200) {
                this.resellerOptions = res.data.resellerList;
            }
        },
        onSearch: async function (resetPage) {
            if (resetPage) {
                this.current = 1;
            }
            this.tableLoading = true;
            let submitData = {
                name: this.filterForm.name,
                publishStartTime: this.filterForm.date ? this.filterForm.date[0] : "",
                publishEndTime: this.filterForm.date ? this.filterForm.date[1] : "",
                reportStartTime: this.filterForm.date2 ? this.filterForm.date2[0] : "",
                reportEndTime: this.filterForm.date2 ? this.filterForm.date2[1] : "",
                size: 10,
                current: this.current
            };
            let res = await window.instance.post(
                openSurveyReqUrl + "statistic/questionnaires",
                submitData
            );
            res = res.data;
            if (res.code === 200) {
                const list = res.data.list;
                this.total = res.data.total;
                this.tableData = list;
            }
            this.tableLoading = false;
        },
        currentChange: function (index) {
            // 分页
            this.current = index;
            this.onSearch(false);
        },
        onReset: function () {
            this.filterForm = _.cloneDeep(this.initFilterForm);
        },
        // getCanDownload: async function () {
        //     let { data } = await window.instance.get(
        //         openSurveyReqUrl + "account/canViewReport"
        //     );
        //     this.canDownload = data.data.result;
        // },
        toStatisticDetail: function (item) {
            let query = { id: item.id, name: item.name };
            if (this.filterForm.date2) {
                query.startTime = this.filterForm.date2[0];
                query.endTime = this.filterForm.date2[1];
            }
            this.$router.push({ path: "/openSurvey/statisticDetail", query });
        }
    }
};
</script>

<style scoped lang="sass">
  </style>


// WEBPACK FOOTER //
// src/openSurvey/pages/StatisticList.vue